import React, { useEffect, useRef, useState } from "react";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage, db } from "../../utils/firebase";
import { setDoc, doc, getDoc, deleteDoc } from "firebase/firestore";
import { ReactComponent as Loading } from "../../assets/icons/loading.svg";
import { useNavigate } from "react-router";
import { ReactComponent as Eye } from "../../assets/icons/eye.svg";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { fetchThisTutorData, fetchThisUserData } from "../../utils/fetchData";
import { useSelector } from "react-redux";

function SignupForm({ hasBeenApproved, email, user, approvalRefID }) {
  const navigate = useNavigate();
  const tutorInfoForm = useRef();
  const thisUser = useSelector((state) => state.thisUser.user);
  const [uploading, setUploading] = useState(false);
  const [image, setImage] = useState(null);

  const [passwordRevealed, setPasswordRevealed] = useState({
    n: true,
    c: true,
  });

  const [tutorInfo, setTutorInfo] = useState({
    emailAddress: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    major: "",
    subjects: "",
    description: "",
    profileImage: null,
    password: "",
    passwordConfirmation: "",
    profileImageUrl: "",
    uid: user?.uid || "defaultUID",
  });

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const deleteApprovalReference = async () => {
    // const thisApprovalRef = doc(db, "approvedApplicants", approvalRefID);
    // await deleteDoc(thisApprovalRef);
  };

  const isValidImageFile = () => {
    if (!tutorInfo.profileImage) return true;

    var fileInput = document.getElementById("profileImage-input");
    var filePath = fileInput.value;
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic)$/i;
    console.log(filePath);
    if (!allowedExtensions.exec(filePath)) {
      document.getElementById(
        "tutor-signup-form-error-msg-fileformat"
      ).innerHTML = "Only .jpeg .jpg .png .heic are allowed.";
      fileInput.value = "";
      return false;
    } else {
      return true;
    }
  };

  const registerUserAndTutor = async (email, password, url) => {
    const auth = getAuth();
    await createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        const newUserUID = userCredential.user.uid;
        console.log(newUserUID);
        // SG 08/07/2022 22:08  creating user document
        await setDoc(doc(db, "users", newUserUID), {
          firstName: capitalizeFirstLetter(tutorInfo.firstName),
          lastName: capitalizeFirstLetter(tutorInfo.lastName),
          major: tutorInfo.major,
          picturePath: url,
          isDarkMode: false,
          email: tutorInfo.emailAddress,
          classes: [],
        }).then(async () => {
          // SG 08/07/2022 22:26  add a tutor with new uid
          await setDoc(doc(db, "tutors", newUserUID), {
            firstName: capitalizeFirstLetter(tutorInfo.firstName),
            lastName: capitalizeFirstLetter(tutorInfo.lastName),
            contactInfo: {
              phoneNumber: tutorInfo?.phoneNumber || "",
              emailAddress: tutorInfo.emailAddress,
            },
            description: tutorInfo.description,
            major: tutorInfo.major,
            profileImagePath: url,
            rating: 0,
            specialization: tutorInfo.subjects.split(","),
            reviews: {
              count: 0,
              reviewers: [],
            },
            uid: newUserUID,
          })
            .then(async () => {
              console.log("success!");
              //TODO here it throws an error because user.uid is undefined
              await deleteApprovalReference();
              await fetchThisUserData();
              await fetchThisTutorData();
              navigate("/signup-success");
            })
            .catch((e) => {
              setUploading(false);
            });
        });
      })
      .catch((error) => {
        // SG 08/08/2022 16:02  user registration failed
        setUploading(false);
      });
  };

  const uploadImage = async (image) => {
    return new Promise((resolve, reject) => {
      const fileName = `${image.name} ${Math.random().toFixed(3)}`;
      const storageRef = ref(storage, `/Tutor-Images/${fileName}`);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
        },
        (err) => {
          console.log(err);
          alert(
            "Something went wrong. Please try again or check your picture format."
          );
          setUploading(false);
          reject(err);
        },
        async () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then(async (url) => {
            resolve(url);
          });
        }
      );
    });
  };

  const handleRegister = async () => {
    setUploading(true);
    let imageUrl = "";

    if (tutorInfo.profileImage) {
      await uploadImage(tutorInfo.profileImage).then((url) => {
        imageUrl = url;
      });
    } else {
      imageUrl = tutorInfo.profileImageUrl;
    }
    setTutorInfo({ ...tutorInfo, profileImageUrl: imageUrl });
    if (!user) {
      await registerUserAndTutor(
        tutorInfo.emailAddress,
        tutorInfo.password,
        imageUrl
      );
    } else {
      if (image) {
        await setDoc(
          doc(db, "tutors", thisUser.id),
          {
            profileImagePath: imageUrl,
          },
          { merge: true }
        ).catch((e) => console.log(e.message));
        await setDoc(
          doc(db, "users", thisUser.id),
          {
            picturePath: imageUrl,
          },
          { merge: true }
        ).catch((e) => console.log(e.message));
      }
      console.log(user.uid);
      await setDoc(doc(db, "tutors", user.uid), {
        firstName: capitalizeFirstLetter(tutorInfo.firstName),
        lastName: capitalizeFirstLetter(tutorInfo.lastName),
        contactInfo: {
          phoneNumber: tutorInfo?.phoneNumber || "",
          emailAddress: tutorInfo.emailAddress,
        },
        description: tutorInfo.description,
        major: tutorInfo.major,
        profileImagePath: imageUrl,
        rating: 0,
        specialization: tutorInfo.subjects.split(","),
        reviews: {
          count: 0,
          reviewers: [],
        },
        uid: user.uid,
      })
        .then(async () => {
          console.log("success!");
          deleteApprovalReference();
          await fetchThisUserData();
          await fetchThisTutorData();
          navigate("/signup-success");
        })
        .catch((e) => {
          alert(e.message + "1");
          setUploading(false);
        });
    }
  };

  const passwordsMatched = () => {
    if (tutorInfo.passwordConfirmation !== tutorInfo.password) {
      document.getElementById("tutor-signup-form-error-msg").innerHTML =
        "Passwords do not match";
      return false;
    } else {
      document.getElementById("tutor-signup-form-error-msg").innerHTML = "";
      return true;
    }
  };

  useEffect(() => {
    setTutorInfo({ ...tutorInfo, emailAddress: email });
  }, [email]);

  useEffect(() => {
    if (user) {
      fetchThisUserData();
    }
  }, [user]);

  useEffect(() => {
    if (hasBeenApproved && tutorInfoForm.current) {
      setTimeout(() => {
        if (document.getElementById("approved-tutor-signup-form")) {
          document.getElementById("approved-tutor-signup-form").scrollIntoView({
            behavior: "smooth",
          });
        }
        tutorInfoForm.current.style.transform = "scale(1)";
      }, 400);
    }
  }, [hasBeenApproved]);

  useEffect(() => {
    if (thisUser) {
      setTutorInfo({
        ...tutorInfo,
        firstName: thisUser.firstName,
        lastName: thisUser.lastName,
        major: thisUser.major,
        profileImageUrl: thisUser.picturePath,
      });
    }
  }, [thisUser]);

  useEffect(() => {
    if (document.getElementById("tutor-signup-description")) {
      document.getElementById("tutor-signup-description").style.height = "5px";
      document.getElementById("tutor-signup-description").style.height =
        document.getElementById("tutor-signup-description").scrollHeight + "px";
    }
  }, [tutorInfo.description]);

  if (!hasBeenApproved || (user && !thisUser)) return null;

  return (
    <div
      ref={tutorInfoForm}
      className="scale-[1px] transition duration-300 ease-in-out w-fit p-5 mb-20"
    >
      <p id="approved-tutor-signup-form"></p>
      <p className="text-[1.4em] md:text-[1.8em] font-semibold text-gray-700 mt-20 mb-5">
        Congratulations! You have been approved!
      </p>
      <p className="text-[1.2em] md:text-[1.3em] font-medium text-gray-700 mb-[3em]">
        Please fill out the form
      </p>

      <form
        className="flex flex-col max-w-[300px] md:max-w-[700px]"
        onSubmit={async (e) => {
          e.preventDefault();
          if (passwordsMatched() && isValidImageFile()) {
            await handleRegister();
          }
        }}
      >
        <p className="text-[1.15em] text-gray-600 font-semibold mb-1">
          Contact Information
        </p>
        <p className="text-[.9em] text-gray-800 font-medium mb-10">
          *This information will be displayed in app for the users to contact
          you.
        </p>
        <div className="flex flex-1 justify-between flex-wrap gap-7 mb-[3em]">
          <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative flex-1">
            <p
              className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                tutorInfo?.emailAddress
                  ? "translate-x-0 -translate-y-6 bg-white "
                  : "translate-x-2"
              }`}
            >
              Email Address *
            </p>
            {user ? (
              // SG 08/07/2022 22:53  if user has logged in, they can only use their account email for tutor
              <input
                readOnly
                required
                type="email"
                value={thisUser.email}
                className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
              />
            ) : (
              <input
                required
                type="email"
                className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                value={tutorInfo.emailAddress}
                onChange={(e) =>
                  setTutorInfo({ ...tutorInfo, emailAddress: e.target.value })
                }
              />
            )}
          </div>
          <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative flex-1">
            <p
              className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                tutorInfo?.phoneNumber
                  ? "translate-x-0 -translate-y-6 bg-white "
                  : "translate-x-2"
              }`}
            >
              Phone Number
            </p>
            <input
              className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
              value={tutorInfo?.phoneNumber}
              onChange={(e) =>
                setTutorInfo({ ...tutorInfo, phoneNumber: e.target.value })
              }
            />
          </div>
        </div>

        <p className="text-[1.15em] text-gray-600 font-semibold mb-5">
          Other information *
        </p>

        <div className="flex flex-1 justify-between flex-wrap gap-7 mb-7">
          <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative flex-1">
            <p
              className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                tutorInfo?.firstName
                  ? "translate-x-0 -translate-y-6 bg-white "
                  : "translate-x-2"
              }`}
            >
              First Name *
            </p>
            <input
              required
              className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
              value={tutorInfo?.firstName}
              onChange={(e) =>
                setTutorInfo({ ...tutorInfo, firstName: e.target.value })
              }
            />
          </div>
          <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative flex-1">
            <p
              className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                tutorInfo?.lastName
                  ? "translate-x-0 -translate-y-6 bg-white "
                  : "translate-x-2"
              }`}
            >
              Last Name *
            </p>
            <input
              required
              className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
              value={tutorInfo?.lastName}
              onChange={(e) =>
                setTutorInfo({ ...tutorInfo, lastName: e.target.value })
              }
            />
          </div>
        </div>

        <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative mb-7">
          <p
            className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
              tutorInfo?.major
                ? "translate-x-0 -translate-y-6 bg-white "
                : "translate-x-2"
            }`}
          >
            Major *
          </p>
          <input
            required
            className="flex-1 px-3 w-full bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
            value={tutorInfo?.major}
            onChange={(e) =>
              setTutorInfo({ ...tutorInfo, major: e.target.value })
            }
          />
        </div>

        <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative mb-7">
          <p
            className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
              tutorInfo?.subjects
                ? "translate-x-0 -translate-y-6 bg-white "
                : "translate-x-2"
            }`}
          >
            Subjects (Seprated by commas) *
          </p>
          <input
            required
            className="flex-1 px-3 w-full bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
            value={tutorInfo?.subjects}
            onChange={(e) =>
              setTutorInfo({ ...tutorInfo, subjects: e.target.value })
            }
          />
        </div>

        <div className="rounded-xl py-3 min-h-[5em] pl-2 border-[2px] bg-white relative">
          <p
            className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
              tutorInfo?.description
                ? "translate-x-0 -translate-y-6 bg-white "
                : "translate-x-2"
            }`}
          >
            Your description, greetings*
          </p>
          <textarea
            required
            id="tutor-signup-description"
            className="flex-1 px-3 w-full bg-transparent h-auto outline-none text-gray-800 text-[1.1em] font-medium resize-none"
            value={tutorInfo?.description}
            onChange={(e) =>
              setTutorInfo({ ...tutorInfo, description: e.target.value })
            }
          />
        </div>
        <p className="text-[1.15em] text-gray-600 font-semibold mt-10">
          Profile Picture *
        </p>
        {thisUser?.picturePath && !image ? (
          <>
            <img
              alt="this user's profile"
              src={thisUser?.picturePath}
              className="object-fit w-[5em] h-[5em] rounded-full"
            />
            <input
              id="profileImage-input"
              className="mt-5 mb-3"
              type="file"
              accept="image/*"
              onChange={(e) => {
                if (e.target.files && e.target.files[0]) {
                  setImage(URL.createObjectURL(e.target.files[0]));
                  setTutorInfo({
                    ...tutorInfo,
                    profileImage: e.target.files[0],
                  });
                }
              }}
            />
          </>
        ) : (
          <>
            {image && (
              <img
                alt="this user's profile"
                src={image}
                className="object-fit w-[5em] h-[5em] rounded-full"
              />
            )}
            <input
              id="profileImage-input"
              required
              className="mt-5 mb-3"
              type="file"
              accept="image/*"
              onChange={(e) => {
                if (e.target.files && e.target.files[0]) {
                  setImage(URL.createObjectURL(e.target.files[0]));
                  setTutorInfo({
                    ...tutorInfo,
                    profileImage: e.target.files[0],
                  });
                }
              }}
            />
          </>
        )}
        <p
          id="tutor-signup-form-error-msg-fileformat"
          className="text-red-500 mb-8"
        ></p>

        {!user && (
          <>
            <p className="text-[1.15em] text-gray-600 font-semibold mb-7">
              Account Password
            </p>

            <div className="flex flex-1 justify-between flex-wrap gap-7 mb-7">
              <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative flex pr-[2em]">
                <p
                  className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                    tutorInfo?.password
                      ? "translate-x-0 -translate-y-6 bg-white "
                      : "translate-x-2"
                  }`}
                >
                  Password *
                </p>
                <input
                  type={passwordRevealed.n ? "password" : "text"}
                  required
                  className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                  value={tutorInfo?.password}
                  onChange={(e) =>
                    setTutorInfo({ ...tutorInfo, password: e.target.value })
                  }
                />
                <Eye
                  className=""
                  onClick={() => {
                    setPasswordRevealed({
                      ...passwordRevealed,
                      n: !passwordRevealed.n,
                    });
                  }}
                />
              </div>
              <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative flex pr-[2em]">
                <p
                  className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                    tutorInfo?.passwordConfirmation
                      ? "translate-x-0 -translate-y-6 bg-white "
                      : "translate-x-2"
                  }`}
                >
                  Password Confirmation *
                </p>
                <input
                  type={passwordRevealed.c ? "password" : "text"}
                  required
                  className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                  value={tutorInfo?.passwordConfirmation}
                  onChange={(e) =>
                    setTutorInfo({
                      ...tutorInfo,
                      passwordConfirmation: e.target.value,
                    })
                  }
                />
                <Eye
                  className=""
                  onClick={() => {
                    setPasswordRevealed({
                      ...passwordRevealed,
                      c: !passwordRevealed.c,
                    });
                  }}
                />
              </div>
            </div>
          </>
        )}
        <p id="tutor-signup-form-error-msg" className="text-red-500"></p>
        <button
          type="submit"
          className="p-3 w-[10em] flex justify-center bg-black text-white rounded-sm mt-10 font-semibold transition duration-300 ease-in-out hover:scale-[1.07]"
        >
          {uploading ? (
            <Loading className="animate-spin" color="white" />
          ) : (
            "Register"
          )}
        </button>
      </form>
    </div>
  );
}

export default SignupForm;
